module.exports = __webpack_public_path__ + "img/laitmaternel.75f6196d.png";